module.exports = __webpack_public_path__ + "img/qq-group-title.3d901892.png";